import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
// model

import { ComboTurmaPos } from './../../../providers/model/comboTurmaPos.model';
import { DisciplinaResultadoPosModel } from './../../../providers/model/disciplina-resultado-pos.model';
//services

import { ConsultaPosService } from './../../../providers/service/pos/consulta-pos.service';
export class ConsultaPosComponent implements OnInit {

  subscription: Subscription;
public habilitarCarregando: boolean = false;
public codigoEmpresa: number;
public codigoInstituicao: number;
public rgmAluno: number;
public listaCombo: ComboTurmaPos[];
public turmaSelecionada: number;
public listaDisciplina: DisciplinaResultadoPosModel[];
/**
 * @param {?} consulta
 * @param {?} rotaAtivada
 */
constructor(private consulta: ConsultaPosService,
private rotaAtivada: ActivatedRoute) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.rotaAtivada.params.subscribe(p => {
      this.codigoEmpresa = p['codigoEmpresa'];
      this.codigoInstituicao = p['codigoInstituicao'];
      this.rgmAluno = p['rgmAluno'];

      this.buscaCombo();
    });
  }
/**
 * @return {?}
 */
public buscaCombo() {
    this.habilitarCarregando = true;

    this.subscription = this.consulta.getCombo(this.codigoInstituicao, this.rgmAluno, this.codigoEmpresa)
      .subscribe(
        (element: ComboTurmaPos[]) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          this.listaCombo = element;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao carregar combo", error)
        }
      );
  }
/**
 * @param {?} item
 * @return {?}
 */
public changeCombo(item: any) {
    this.turmaSelecionada = item;

    this.buscaDisciplina(this.rgmAluno, this.codigoInstituicao, this.codigoEmpresa, this.turmaSelecionada);
  }
/**
 * @param {?} rgmAluno
 * @param {?} codigoInstituicao
 * @param {?} codigoEmpresa
 * @param {?} codigoTurma
 * @return {?}
 */
public buscaDisciplina(rgmAluno: number, codigoInstituicao: number, codigoEmpresa: number, codigoTurma: number) {
    this.habilitarCarregando = true;
    this.subscription = this.consulta.getDisciplinas(rgmAluno, codigoInstituicao, codigoEmpresa, codigoTurma)
      .subscribe(
        (element: DisciplinaResultadoPosModel[]) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          this.listaDisciplina = element;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao carregar combo", error)
        }
      );
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-consulta-pos',
  template: `
    <app-carregando *ngIf="habilitarCarregando"></app-carregando>

    <div style="text-align:center">
      <h1>
        Nota Pós
      </h1>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <label for="comboTurma">Turma</label>
          <select class="form-control" id="comboturma" name="ComboTurma" [(ngModel)]="turmaSelecionada" (change)="changeCombo($event.target.value)">
            <option *ngFor="let item of listaCombo" [value]="item.codigoTurma">{{item.descricao}}</option>
          </select>
        </div>
      </div>
      <br>

      <div class="panel panel-default">
        <!-- Default panel contents -->
        <div class="table-responsive"></div>

        <!-- Table -->
        <table id="tableDisciplina" class="table table-bordered">
          <thead>
            <th>Disciplina</th>
            <th>Nota Final</th>
            <th>Resultado</th>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaDisciplina">
              <td>{{item.descricao}}</td>
              <td>{{item.notaFinal}}</td>
              <td>{{item.resultado}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div style="text-align:center">
      <p align="center" class="tabela_atencao" style="width:500px; padding:3px">
        <span class="texto04_vermelho">S/N - Sem Nota Processada
          <br> Extrato para simples conferência, sujeito a alteração. Documento não oficial.
        </span>
      </p>
    </div>
  `,
  styles: [`
     th {
        background-color: #DBEBFF;
        border: 1px solid #A4BED4;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 13px;
        color: #006699;
        font-weight: bold;
        text-align: center;
        cursor: default;
    }

    td{
        border: 1px solid #cccccc;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 13px;
    }

    .tabela_atencao {
        border: 1px solid #FFCC00;
        background-color: #FFF8D9;
        font: 12px Verdana, Arial, Helvetica, sans-serif;
        color: #CC0000;
        text-align: center;
    }
  `],
  providers: [ConsultaPosService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConsultaPosService, },
{type: ActivatedRoute, },
];
}

function ConsultaPosComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaPosComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaPosComponent.ctorParameters;
/** @type {?} */
ConsultaPosComponent.prototype.subscription;
/** @type {?} */
ConsultaPosComponent.prototype.habilitarCarregando;
/** @type {?} */
ConsultaPosComponent.prototype.codigoEmpresa;
/** @type {?} */
ConsultaPosComponent.prototype.codigoInstituicao;
/** @type {?} */
ConsultaPosComponent.prototype.rgmAluno;
/** @type {?} */
ConsultaPosComponent.prototype.listaCombo;
/** @type {?} */
ConsultaPosComponent.prototype.turmaSelecionada;
/** @type {?} */
ConsultaPosComponent.prototype.listaDisciplina;
/** @type {?} */
ConsultaPosComponent.prototype.consulta;
/** @type {?} */
ConsultaPosComponent.prototype.rotaAtivada;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
